export const UPDATE_ROLES_STATE = "UPDATE_ROLES_STATE"
export const PERMISSION_ADDED = "PERMISSION_ADDED"
export const R_Member= "R_Member"
